import { MemSerializer } from '#kv-storage/drivers/mem/serializer';
import { clearGeneric, dropInstanceGeneric, getItemGeneric, initStorageGeneric, iterateGeneric, keyGeneric, keysGeneric, lengthGeneric, removeItemGeneric, setItemGeneric, } from '#kv-storage/drivers/methods';
import { Storage } from './storage';
function initStorage(options) {
    const generic = (initStorageGeneric);
    return generic.apply(this, [
        options,
        () => new Storage(),
        (serializer) => new MemSerializer(serializer),
    ]);
}
function getItem(key, callback) {
    const generic = (getItemGeneric);
    return generic.apply(this, [key, callback]);
}
function setItem(key, value, callback) {
    const generic = (setItemGeneric);
    return generic.apply(this, [key, value, callback]);
}
function removeItem(key, callback) {
    const generic = (removeItemGeneric);
    return generic.apply(this, [key, callback]);
}
function clear(callback) {
    const generic = (clearGeneric);
    return generic.apply(this, [callback]);
}
function length(callback) {
    const generic = (lengthGeneric);
    return generic.apply(this, [callback]);
}
function key(n, callback) {
    const generic = (keyGeneric);
    return generic.apply(this, [n, callback]);
}
function keys(callback) {
    const generic = (keysGeneric);
    return generic.apply(this, [callback]);
}
function iterate(iteratee, callback) {
    const generic = (iterateGeneric);
    return generic.apply(this, [iteratee, callback]);
}
function dropInstance(dbInstanceOptions, callback) {
    const generic = (dropInstanceGeneric);
    return generic.apply(this, [dbInstanceOptions, callback]);
}
export const MemDriver = {
    _driver: 'MemDriver',
    _initStorage: initStorage,
    getItem,
    setItem,
    removeItem,
    clear,
    length,
    key,
    keys,
    iterate,
    dropInstance,
};
